<template>
  <div :class="{ 'progress--mini': isMini }" class="progress">
    <div v-if="isMini" class="progress__label">Your progress</div>
    <div class="progress__bar">
      <div
        :style="{ transform: `translateX(${percentage - 100}%)` }"
        class="progress__bar__filled"
      ></div>
    </div>
    <div
      :class="{ 'progress__percentage--icon': percentage === 100 }"
      class="progress__percentage"
    >
      <i v-if="percentage === 100" class="icon icon-tick"></i>
      <div v-else>{{ percentage + "%" }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentage: Number,
    isMini: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

.progress {
  height: 30px;
  display: flex;
  align-items: center;

  &__label {
    position: absolute;
    top: -16px;
    @include global-interactive-label-small;
    color: #fff;
  }

  &__bar {
    width: 260px;
    height: 10px;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;

    &__filled {
      background-color: #6cdc9f;
      width: 100%;
      height: 100%;
      border-radius: 5px;
      transform: translateX(-50%);
      transition: transform 0.3s;
    }
  }

  &__percentage {
    margin-left: 16px;

    &--icon {
      height: 24px;
    }
  }

  &--mini {
    position: absolute;
    right: 82px;
    top: 60%;
    transform: translateY(-50%);
    width: 304px;

    .progress__percentage {
      font-size: 14px;
      font-weight: bold;
      line-height: 17px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue